import { languageIndex } from "@utils";
export const fields = (language, englishPlaceholder, russianPlaceholder, englishWarning, russianWarning) => {
    const index = languageIndex(language);
    return {
        placeholder: [englishPlaceholder, russianPlaceholder][index],
        warning: [englishWarning, russianWarning][index],
    };
};
